// extracted by mini-css-extract-plugin
export default {"recoverAccountContainer":"RecoverAccount_recoverAccountContainer__UfT1t"};